import { jsx as _jsx } from "react/jsx-runtime";
import { Avatar, Tooltip } from "@mui/material";
import { Link } from "react-router-dom";
export const TeamSearchResultAvatar = ({ teamSearchResult, size = 56, }) => {
    const displayName = teamSearchResult.name;
    const tooltip = (_jsx(Tooltip, { title: displayName, arrow: true, children: _jsx(Avatar, { src: teamSearchResult.logo || undefined, alt: displayName, sx: { width: size, height: size }, children: displayName.match(/\b(\w)/g)?.join("") }) }));
    return (_jsx(Link, { style: { textDecoration: "none" }, to: `/teams/${teamSearchResult.id}/`, children: tooltip }, teamSearchResult.id));
};
